import React from 'react';
import PropTypes from 'prop-types';

import './SrFlexRow.less';

const SrFlexRow = ({
  children,
  width,
  marginTop,
  className,
}) => {
  return (
    <div
      className={className}
      styleName='SrFlexRow'
      style={{ width, marginTop }}
    >
      {children}
    </div>
  );
};

SrFlexRow.propTypes = {
  children: PropTypes.node,
  width: PropTypes.string,
  className: PropTypes.string,
};

SrFlexRow.defaultProps = {
  width: '100%',
};

SrFlexRow.displayName = 'SrFlexRow';

export default SrFlexRow;
